module.exports = __webpack_public_path__ + "static/media/pdf-file-format-symbol.78c9e728.svg";